
import axios from 'axios';

export const propertiesAPI = {
    getCardData: async (propertyCardDetailRequest) => {
        // Use new Node.js backend for CardDetail endpoint
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'post',
                url: `${NEW_API_BASE_URL}/api/property/carddetail`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: propertyCardDetailRequest,
            });
            return response.data;
        } catch (error) {
            console.error('Error during getCardData request to new backend:', error);
            throw error;
        }
    },
    getPropertyDetail: async (uniquePropertyRequest) => {
        // Use new Node.js backend for Detail endpoint
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'post',
                url: `${NEW_API_BASE_URL}/api/property/detail`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: uniquePropertyRequest,
            });
            return response.data;
        } catch (error) {
            console.error('Error during getPropertyDetail request to new backend:', error);
            throw error;
        }
    },
    getLocations: async () => {
        // Use new Node.js backend for Locations endpoint
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'get',
                url: `${NEW_API_BASE_URL}/api/property/locations`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error during getLocations request to new backend:', error);
            throw error;
        }
    },
    getSoldLocations: async () => {
        // Use new Node.js backend for SoldLocations endpoint
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'get',
                url: `${NEW_API_BASE_URL}/api/property/soldlocations`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error during getSoldLocations request to new backend:', error);
            throw error;
        }
    },
    getStates: async () => {
        // Use new Node.js backend for States endpoint
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'get',
                url: `${NEW_API_BASE_URL}/api/property/states`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error during getStates request to new backend:', error);
            throw error;
        }
    },
    getCounties: async () => {
        // Use new Node.js backend for Counties endpoint
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'get',
                url: `${NEW_API_BASE_URL}/api/property/counties`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                },
            });
            // Filter out test county data (matching old backend behavior)
            return response.data.filter(county => county.name !== 'ZZZ-bad Parish');
        } catch (error) {
            console.error('Error during getCounties request to new backend:', error);
            throw error;
        }
    },
    getPropertySaleTypes: async () => {
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'get',
                url: `${NEW_API_BASE_URL}/api/property/saletypes`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error during getPropertySaleTypes request to new backend:', error);
            throw error;
        }
    },
    getSaleStatus: async () => {
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'get',
                url: `${NEW_API_BASE_URL}/api/property/salestatus`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error during getSaleStatus request to new backend:', error);
            throw error;
        }
    },
    getStateList: async () => {
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'get',
                url: `${NEW_API_BASE_URL}/api/property/statelist`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error during getStateList request to new backend:', error);
            throw error;
        }
    },
    getCountyList: async () => {
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'get',
                url: `${NEW_API_BASE_URL}/api/property/countylist`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            return response.data;
        } catch (error) {
            console.error('Error during getCountyList request to new backend:', error);
            throw error;
        }
    },
    getSaleDateList: async (selectDateRequest) => {
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'post',
                url: `${NEW_API_BASE_URL}/api/property/saledates`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: selectDateRequest,
            });
            return response.data;
        } catch (error) {
            console.error('Error during getSaleDateList request to new backend:', error);
            throw error;
        }
    },
    mapProperties: async (mapPropertyRequest) => {
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'post',
                url: `${NEW_API_BASE_URL}/api/property/map`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: mapPropertyRequest,
            });
            return response.data;
        } catch (error) {
            console.error('Error during mapProperties request to new backend:', error);
            throw error;
        }
    },
    getPropertyListDownload: async (propertyCardDetailRequest) => {
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'post',
                url: `${NEW_API_BASE_URL}/api/property/downloadpropertylist`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: propertyCardDetailRequest,
            });
            return response.data;
        } catch (error) {
            console.error('Error during getPropertyListDownload request to new backend:', error);
            throw error;
        }
    },
    getCountyDetailInformation: async (countyDetailRequest) => {
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'post',
                url: `${NEW_API_BASE_URL}/api/property/countydetailinformation`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: countyDetailRequest,
            });
            return response.data;
        } catch (error) {
            console.error('Error during getCountyDetailInformation request to new backend:', error);
            throw error;
        }
    },
    getCountySalesInformation: async (countyDetailRequest) => {
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        try {
            const response = await axios({
                method: 'post',
                url: `${NEW_API_BASE_URL}/api/property/countysalesinformation`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: countyDetailRequest,
            });
            return response.data;
        } catch (error) {
            console.error('Error during getCountySalesInformation request to new backend:', error);
            throw error;
        }
    },
    getAuctionListAll: async (startIndex = 0, recordCount = 25) => {
        const today = new Date().toISOString().split('T')[0]; // Get today's date in YYYY-MM-DD format

        // Uses new Node.js backend endpoint
        const NEW_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_SERVER_URL;
        const NEW_API_KEY = process.env.REACT_APP_SERVER_API_KEY;

        const data = {
            searchText: "",
            state: "",
            county: "",
            propertySaleType: "",
            auctionStyle: "",
            saleStatus: "",
            auctionDateRange: {
                startDate: today,
                endDate: "",
                compareOperator: ">"
            },
            recordCount,  // Use passed-in recordCount
            startIndex   // Use passed-in startIndex
        };

        try {
            const response = await axios({
                method: 'post',
                url: `${NEW_API_BASE_URL}/api/auction/listall`,
                headers: {
                    'x-api-key': NEW_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                data: data,
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching auction list:', error);
            throw error;
        }
    },
};
